import React from "react";

function SupportTicketViewUi({ handleCloseModal, data }) {
  const getBadgeColor = (status) => {
    switch (status) {
      case "resolved":
        return "bg-success text-white"; // Green badge for completed
      case "rejected":
        return "bg-danger text-white"; // Yellow badge for in progress
      default:
        return "bg-secondary text-white"; // Default gray badge for other statuses
    }
  };
  return (
    <div>
      <div className="modal fade show  d-block">
        <div
          className="modal-dialog d-flex align-items-center"
          style={{ height: "calc(100vh - 72px)" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title">Support Ticket</h4>
                <span
                  className={`badge ${getBadgeColor(data?.status)} ml-3`}
                  style={{ height: "20px" }}
                >
                  {data?.status.charAt(0).toUpperCase() + data?.status.slice(1)}
                </span>
              </div>
              <button
                type="button"
                className="close"
                onClick={handleCloseModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="card-body">
                <div>
                  <p className="mb-1 ">
                    <strong>RRB:</strong>
                  </p>
                  <p className="mb-1">{data?.rrb?.name}</p>
                </div>
                <div>
                  <p className="mb-1 ">
                    <strong>Auditor Name:</strong>
                  </p>
                  <p className="mb-1">
                    {data?.user?.firstname} {data?.user?.lastname}
                  </p>
                </div>
                <div>
                  <p
                    className="mb-1 "
                   
                  >
                    <strong>Query:</strong>
                  </p>
                  <p className="mb-1"  style={{
                      maxWidth: "450px",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                    }}>{data?.query}</p>
                </div>
                {data?.reason ? (
                  <div>
                    <p
                      className="mb-1 "
                    >
                      <strong>Reason:</strong>
                    </p>
                    <p className="mb-1"   style={{
                        width: "450px",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                      }}>{data?.reason}</p>
                  </div>
                ) : null}
              </div>
            </div>
            {/* <div className="modal-footer justify-content-between">
          <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
          <button type="submit" className="btn btn-primary">Save changes</button>
        </div> */}
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* /.modal */}
    </div>
  );
}

export default SupportTicketViewUi;
